// core version + navigation, pagination modules:
import { $qs, $qsa } from "./utils/QuerySelector";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function footer() {
	return;
	const siteFooter = $qs('[data-name="site-footer"]');

	if (!siteFooter) return;

	const timeline = gsap.timeline({
		scrollTrigger: {
			id: "footer-reveal",
			trigger: siteFooter,
			start: "bottom bottom",
			end: () => `+=${siteFooter.offsetHeight - 25}px`,
			scrub: true,
			pin: true,
			invalidateOnRefresh: true,
			// markers: true,
		},
	});

	setTimeout(() => {
		ScrollTrigger.getById("footer-reveal").refresh();
	}, 1000);
}

export default footer;
